import React from "react";
import { Tooltip } from "@sscs/ui";
import { motion } from "framer-motion";
import { unattainedVariant } from "../../../../constants";
import { getBestLevel, getLevelPrefix, isLevelAttained, } from "../../../../utils";
import AttainedLevel from "./AttainedLevel";
import { hasLevelUserOverrides } from "./DiamondTooltip";
import styles from "./levelDiamond.module.scss";
const LevelDiamond = ({ level, inhibitors, tooltipTitle, levelsInfo, }) => {
    const bestLevel = getBestLevel(inhibitors);
    const levelPrefix = getLevelPrefix(inhibitors.customized);
    const isAttained = isLevelAttained(inhibitors, level);
    const isScanLevel = inhibitors.scan_level === level;
    const isBestLevel = bestLevel === level && bestLevel !== inhibitors.scan_level;
    const hasUserOverrides = levelsInfo !== undefined &&
        hasLevelUserOverrides(levelsInfo, inhibitors, level);
    return (React.createElement(Tooltip, { trigger: "graphic", tooltipType: "card", header: `${inhibitors.customized ? "Custom level" : "Level"} ${level}`, title: tooltipTitle, footer: hasUserOverrides && (React.createElement(React.Fragment, null,
            React.createElement("span", { className: styles["tooltip-label-warning"] }, "*"),
            " User customized requirements")) },
        React.createElement("div", null,
            isScanLevel && (React.createElement("div", { className: styles["level-header"] }, "Scan level")),
            isBestLevel && (React.createElement("div", { className: styles["level-header"] }, "Best level")),
            isAttained ? (React.createElement(AttainedLevel, { level: level, inhibitors: inhibitors })) : (React.createElement(motion.div, { variants: unattainedVariant, className: styles["unattained-container"] },
                React.createElement("div", { className: `${styles.level} ${styles["unattained-border"]}` },
                    React.createElement("div", { className: styles["unattained-level"] },
                        React.createElement("div", { className: styles["level-content"] },
                            levelPrefix,
                            level))))))));
};
export default LevelDiamond;
//# sourceMappingURL=LevelDiamond.js.map